/** Setup guides (content/guides/*.md). Screenshot placeholders are marked [SCREENSHOT: …]. */
import { marked } from 'marked';
import { useTranslation } from 'react-i18next';
import { Link } from 'wouter';
import youtube from '../content/guides/youtube.md?raw';
import bigquery from '../content/guides/bigquery.md?raw';
import ga4 from '../content/guides/ga4.md?raw';
import meta from '../content/guides/meta.md?raw';
import googleAds from '../content/guides/google_ads.md?raw';
import searchConsole from '../content/guides/search_console.md?raw';
import woocommerce from '../content/guides/woocommerce.md?raw';
import shoper from '../content/guides/shoper.md?raw';
import stripe from '../content/guides/stripe.md?raw';
import youtubePl from '../content/guides/youtube.pl.md?raw';
import bigqueryPl from '../content/guides/bigquery.pl.md?raw';
import ga4Pl from '../content/guides/ga4.pl.md?raw';
import metaPl from '../content/guides/meta.pl.md?raw';
import googleAdsPl from '../content/guides/google_ads.pl.md?raw';
import searchConsolePl from '../content/guides/search_console.pl.md?raw';
import woocommercePl from '../content/guides/woocommerce.pl.md?raw';
import shoperPl from '../content/guides/shoper.pl.md?raw';
import stripePl from '../content/guides/stripe.pl.md?raw';

const GUIDES: Record<string, Record<string, string>> = { en: { youtube, bigquery, ga4, meta, google_ads: googleAds, search_console: searchConsole, woocommerce, shoper, stripe }, pl: { youtube: youtubePl, bigquery: bigqueryPl, ga4: ga4Pl, meta: metaPl, google_ads: googleAdsPl, search_console: searchConsolePl, woocommerce: woocommercePl, shoper: shoperPl, stripe: stripePl } };

export function Guide({ slug }: { slug: string }) {
  const { t, i18n } = useTranslation();
  const md = GUIDES[i18n.language]?.[slug] ?? GUIDES.en![slug];
  if (!md) return <p>{t('common.notFound')}</p>;
  // Our own trusted content files; render placeholders as visible boxes.
  const html = (marked.parse(md) as string).replace(/<code>\[SCREENSHOT: ([^\]]+)\]<\/code>/g, `<span class="shot">${t('guides.screenshot')}: $1</span>`);
  return (
    <article className="stack guide">
      <Link href="/connections" className="faint">← {t('guides.back')}</Link>
      <div className="prose" dangerouslySetInnerHTML={{ __html: html }} />
    </article>
  );
}
